import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { OwnerFamilyService } from "../../service/owner-family.service";
import { LOAD_LATEST_TOS, SET_LATEST_TOS } from "./selected-variables.actions";
import { exhaustMap, map } from "rxjs";
import { retry } from "rxjs/operators";


@Injectable()
export class SelectedVariablesEffects {
  constructor(private actions: Actions,
              private ownerFamilyService: OwnerFamilyService) {
  }

  loadLatestToS$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LOAD_LATEST_TOS),
      exhaustMap(() => this.ownerFamilyService.getLatestToS()
        .pipe(
          map(latestToS => ({
            type: SET_LATEST_TOS,
            latestToS: {
              id: latestToS.id,
              version: latestToS.version
            }
          })),
          retry(3)
        )
      )
    );
  });
}
